import axios from "axios";
import { useMutation } from "react-query";
import showToast from "../components/Toast";

// "Ask the Rankings" — public, no auth required.
export const askRankings = async (question) => {
  const response = await axios.post("/api/v1/public/ai/ask", { question });
  return response.data; // { success, data: { answer } }
};

export const useAskRankings = () => {
  return useMutation(askRankings, {
    onError: (error) => {
      showToast(
        error.response?.data?.error || "Something went wrong. Please try again.",
        "error"
      );
    },
  });
};
